module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "home",
    attrs: {
      "data-toggle": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "background"
  }, [_c('background-vector', {
    staticClass: "home__vector",
    attrs: {
      "alpha": 0.25,
      "scale": _vm.backgroundScale,
      "viewbox": {
        offsetX: _vm.offsetX,
        offsetY: _vm.offsetY
      }
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "background__banner home__banner toggle-content"
  }, [_vm._v(_vm._s(_vm.content.banner))])], 1), _vm._v(" "), _c('section', {
    staticClass: "home__content home__desc toggle-content"
  }, [_c('h1', {
    staticClass: "home__title"
  }, [_vm._v(_vm._s(_vm.content.title))]), _vm._v(" "), _c('h2', {
    staticClass: "home__subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.content.subtitle)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rte"
  }, _vm._l((_vm.content.text), function(item) {
    return _c(item.component, {
      tag: "component",
      attrs: {
        "item": item
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "home__logos"
  }, _vm._l((_vm.content.logos), function(ref) {
    var url = ref.url;
    var image = ref.image;

    return _c('safe-link', {
      staticClass: "home__link",
      attrs: {
        "url": url
      }
    }, [_c('img', {
      staticClass: "home__link--logo",
      attrs: {
        "src": image.url,
        "alt": image.alt
      }
    })])
  })), _vm._v(" "), _c('button-link', {
    staticClass: "home__cta",
    attrs: {
      "type": "fill",
      "to": _vm.content.path
    }
  }, [_vm._v(_vm._s(_vm.content.label))])], 1), _vm._v(" "), (_vm.$media.mobile) ? _c('h3', {
    staticClass: "home__banner--mobile toggle-content"
  }, [_vm._v(_vm._s(_vm.content.banner))]) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('post-grid', {
    staticClass: "home__content grid--home toggle-content",
    attrs: {
      "posts": _vm.posts,
      "forceColumns": !_vm.$media.mobile,
      "link": {
        to: '/blogue',
        label: _vm.content.bloglabel
      }
    }
  }) : _c('div', {
    staticClass: "home__content toggle-content"
  }), _vm._v(" "), (_vm.$media.phone) ? _c('button-link', {
    staticClass: "grid__link toggle-content",
    attrs: {
      "to": "/blogue",
      "type": "border"
    }
  }, [_vm._v(_vm._s(_vm.content.bloglabel))]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "up"
    }
  }, [_c('router-view', {
    staticClass: "home__panel"
  })], 1), _vm._v(" "), _c('header-nav'), _vm._v(" "), _c('footer-nav', {
    staticClass: "toggle-content",
    attrs: {
      "sidebars": _vm.sidebars
    }
  }), _vm._v(" "), (!_vm.$media.mobile) ? _c('button', {
    staticClass: "home__back",
    on: {
      "click": _vm.navBack
    }
  }, [_vm._v("retour "), _c('icon', {
    attrs: {
      "id": 'return'
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1865841a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/home/Home.vue
// module id = 627
// module chunks = 1